import { render, staticRenderFns } from "./PasswordRestore.vue?vue&type=template&id=607b80e0&scoped=true"
import script from "./PasswordRestore.vue?vue&type=script&lang=js"
export * from "./PasswordRestore.vue?vue&type=script&lang=js"
import style0 from "./PasswordRestore.vue?vue&type=style&index=0&id=607b80e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607b80e0",
  null
  
)

export default component.exports